import React from 'react';
import { connect } from 'react-redux';
import { getLocaleId } from '../../api/redux-watson/watson-config-selectors';

class DocLang extends React.Component {
  componentDidMount() {
    this.updateLang();
  }

  componentDidUpdate() {
    this.updateLang();
  }

  updateLang() {
    const el = document.getElementsByTagName('html')[0];
    const code = this.props.lang.split('-')[0];
    el.setAttribute('lang', code);
  }

  render() {
    return null;
  }
}

export default connect(state => ({
  lang: getLocaleId(state),
}))(DocLang);



// WEBPACK FOOTER //
// ./src/app/ui/config/DocLang.js